import { TThunkAction } from '../../../../common/types/thunk';
import { selectIsAuctionSelected } from '../../../selectors/auction';
import { changeAuctionBet } from '../../../actions/auction';
import { reloadBetPosition } from '../../../actions/betPosition';
import { checkServiceAfterChangeBet } from '../../../actions/checkoutInfo';

import { TChangeCurrentBetSource } from './types';
import { selectCurrentBet } from '../../../reducers/v2/promotion/selectors';

interface IParams {
  source?: TChangeCurrentBetSource;
  afterCheckService?: boolean;
  bet: number;
}

export const changeCurrentBet =
  ({ afterCheckService, bet, source }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const isAuctionSelected = selectIsAuctionSelected(state);
    const currentBet = selectCurrentBet(state);

    if (isAuctionSelected && bet !== currentBet) {
      dispatch(
        changeAuctionBet({
          bet,
          changedByUser: !afterCheckService,
        }),
      );
    }

    dispatch(reloadBetPosition());

    if (!afterCheckService && source) {
      dispatch(checkServiceAfterChangeBet(source));
    }
  };
